export default "__VITE_ASSET__BmqDmu_b__"